import axios from "axios";
import toast from "react-hot-toast";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;


export const updateBookingStatus = (bookingStatusData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "UPDATE_BOOKING_STATUS_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/project/catalogue/booking-status`,
        bookingStatusData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "UPDATE_BOOKING_STATUS_SUCCESS", payload: data });
        toast.success("Booking status updated successfully!");
        return data;
      } else {
        dispatch({ type: "UPDATE_BOOKING_STATUS_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "UPDATE_BOOKING_STATUS_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const getProjectList = (projectData, showLoader = true) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "GET_PROJECTS_LIST_REQUEST" });

      const config = { headers: { "Content-Type": "application/json" } };
      const { data } = await axios.post(`${BASE_URL}/project/list`, projectData, config);

      if (data.statusCode === 200) {
        dispatch({ type: "GET_PROJECTS_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_PROJECTS_LIST_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_PROJECTS_LIST_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      if (showLoader) {
        dispatch({ type: "STOP_LOADING" });
      }
    }
  };
};

export const getProjectData = (projectData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "GET_PROJECT_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.get(
        `${BASE_URL}/project/${projectData}`,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_PROJECT_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_PROJECT_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_PROJECT_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const viewProjectCatalogue = (projectData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_PROJECT_CATALOGUE_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/project/catalogue/view`,
        projectData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_PROJECT_CATALOGUE_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_PROJECT_CATALOGUE_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_PROJECT_CATALOGUE_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const addVR = (addVrData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "ADD_VR_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/project/update`,
        addVrData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "ADD_VR_SUCCESS", payload: data });
        toast.success("Added Successfully!!");
        return data;
      } else {
        dispatch({ type: "ADD_VR_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "ADD_VR_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const removeVr = (removeVrData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "REMOVE_VR_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/project/remove-vr`,
        removeVrData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "REMOVE_VR_SUCCESS", payload: data });
        toast.success("VR removed successfully!");
        return data;
      } else {
        dispatch({ type: "REMOVE_VR_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "REMOVE_VR_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const addLandmark = (addLandmarkData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "ADD_LANDMARK_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/project/update`,
        addLandmarkData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "ADD_LANDMARK_SUCCESS", payload: data });
        toast.success("Added Successfully!!");
        return data;
      } else {
        dispatch({ type: "ADD_LANDMARK_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "ADD_LANDMARK_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


export const addReel = (addLandmarkData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "ADD_REEL_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/file/compress-upload`,
        addLandmarkData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "ADD_REEL_SUCCESS", payload: data });
        toast.success("Added Successfully!!");
        return data;
      } else {
        dispatch({ type: "ADD_REEL_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "ADD_REEL_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const addProject = (projectData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "ADD_PROJECT_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/project/add`,
        projectData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "ADD_PROJECT_SUCCESS", payload: data });
        toast.success("Added Successfully!!");
        return data;
      } else {
        dispatch({ type: "ADD_PROJECT_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "ADD_PROJECT_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const editProject = (projectData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "EDIT_PROJECT_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/project/update-project-admin`,
        projectData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "EDIT_PROJECT_SUCCESS", payload: data });
        toast.success("Edit Successful!!");
        return data;
      } else {
        dispatch({ type: "EDIT_PROJECT_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "EDIT_PROJECT_FAILED",
        payload: error?.response?.data?.message,
      });
      return toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const showPriceList = (project) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "SHOW_PRICELIST_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/enquiries/request-to-show-price`,
        project,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "SHOW_PRICELIST_SUCCESS", payload: data });
        toast.success("Price List Loaded!");
        return data;
      } else {
        dispatch({ type: "SHOW_PRICELIST_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "SHOW_PRICELIST_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const updateShowPriceList = (project) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "UPDATE_PRICELIST_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/enquiries/update-show-price`,
        project,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "UPDATE_PRICELIST_SUCCESS", payload: data });
        toast.success("Price List Loaded!");
        return data;
      } else {
        dispatch({ type: "UPDATE_PRICELIST_FAILURE", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "UPDATE_PRICELIST_FAILURE",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


export const viewProjectVideos = (videoId) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "VIEW_PROJECT_VIDEOS_REQUEST" });

      const config = {
        headers: { "Content-Type": "application/json" },
      };

      const { data } = await axios.get(`${BASE_URL}/project/videos/${videoId}`, config);

      if (data.statusCode === 200) {
        dispatch({ type: "VIEW_PROJECT_VIDEOS_SUCCESS", payload: data });
      } else {
        dispatch({ type: "VIEW_PROJECT_VIDEOS_FAILED", payload: data });
        toast.error("Failed to load project videos");
      }
    } catch (error) {
      dispatch({
        type: "VIEW_PROJECT_VIDEOS_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message || "Error loading videos");
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const removeProjectVideo = (removeVideoData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "REMOVE_PROJECT_VIDEO_REQUEST" });

      const config = {
        headers: { "Content-Type": "application/json" },
      };

      const { data } = await axios.post(`${BASE_URL}/project/remove-video`, removeVideoData, config);

      if (data.statusCode === 200) {
        dispatch({ type: "REMOVE_PROJECT_VIDEO_SUCCESS", payload: data });
        toast.success("Video removed successfully!");
      } else {
        dispatch({ type: "REMOVE_PROJECT_VIDEO_FAILED", payload: data });
        toast.error("Failed to remove video");
      }
    } catch (error) {
      dispatch({
        type: "REMOVE_PROJECT_VIDEO_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message || "Error removing video");
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


export const addAR = (arData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "ADD_AR_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/project/addAR`,
        arData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "ADD_AR_SUCCESS", payload: data });
        toast.success("AR added successfully!");
        return data;
      } else {
        dispatch({ type: "ADD_AR_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "ADD_AR_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const listAR = (arListData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "LIST_AR_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/project/listAR`,
        arListData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "LIST_AR_SUCCESS", payload: data });
      } else {
        dispatch({ type: "LIST_AR_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "LIST_AR_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const viewAR = (projectId) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "VIEW_AR_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.get(
        `${BASE_URL}/project/viewAR/${projectId}`,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "VIEW_AR_SUCCESS", payload: data });
      } else {
        dispatch({ type: "VIEW_AR_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "VIEW_AR_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message || "Error loading AR data");
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const updateAR = (arUpdateData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "UPDATE_AR_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/project/updateAR/${arUpdateData.id}`,
        arUpdateData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "UPDATE_AR_SUCCESS", payload: data });
        toast.success("AR updated successfully!");
        return data;
      } else {
        dispatch({ type: "UPDATE_AR_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "UPDATE_AR_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const deleteAR = (deleteData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "DELETE_AR_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/project/deleteAR/${deleteData.id}`,
        deleteData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "DELETE_AR_SUCCESS", payload: data });
        toast.success("AR deleted successfully!");
        return data;
      } else {
        dispatch({ type: "DELETE_AR_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "DELETE_AR_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};